import { render, staticRenderFns } from "./PagedList.vue?vue&type=template&id=1f9beade&scoped=true"
import script from "./PagedList.vue?vue&type=script&lang=js"
export * from "./PagedList.vue?vue&type=script&lang=js"
import style0 from "./PagedList.vue?vue&type=style&index=0&id=1f9beade&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f9beade",
  null
  
)

export default component.exports